import React from 'react';
import { observer } from 'mobx-react-lite';
import { oddStore } from '../../../store';

export const RenderOdd = observer(() => {
  const { oddData } = oddStore;
  return !!oddData && <p className='crash-game-coefficient-num-txt'>x{oddData.toFixed(2)}</p>;
});
